import { SVG, SVGProps } from './svg'

export function IconToolMouse(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 32 32">
      <path d="M19 21l-2.1-5 2.6.2c.6 0 .9-.6.5-1l-7-7c-.4-.5-1-.2-1 .3l-.1 9.9c0 .6.7.8 1 .4l1.7-1.9 2 5c.2.4.5.5.8.4l1.3-.5c.3-.1.5-.5.3-.8z" />
    </SVG>
  )
}
